import { PipeTransform, Pipe } from "@angular/core";
import { Vat } from "../Model/Vat.Model";
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'VatFilter',
  standalone: false
})
export class VatFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(Vats: Vat[], searchTerm: string, field: string): Vat[] {
    if (!Vats || !searchTerm) {
      return Vats;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();

    return Vats.filter(vat =>
      this.matchesSearchTerm(vat, lowerSearchTerm)
    );
  }

  private matchesSearchTerm(vat: Vat, term: string): boolean {
    return (
      this.stringMatches(vat.vatId, term) ||
      this.stringMatches(vat.vatRate, term) ||
      this.stringMatches(vat.applicationDate, term) ||
      this.stringMatches(vat.marketCompanyName, term)
    );
  }

  private stringMatches(value: any, term: string): boolean {
    if (value === null || value === undefined) return false;

    // Handle Date type
    if (value instanceof Date) {
      return value.toLocaleString().toLowerCase().includes(term);
    }

    // Handle number type
    if (typeof value === 'number') {
      return value.toLocaleString().toLowerCase().includes(term);
    }

    // Handle string type
    if (typeof value === 'string') {
      return value.toLowerCase().includes(term);
    }

    // Handle cases where the value might be an unexpected type (e.g., Float64Array)
    if (value instanceof Float64Array) {
      // Convert each number in the Float64Array to string and check for a match
      return Array.from(value).some(item => item.toLocaleString().toLowerCase().includes(term));
    }

    // If it's not one of the expected types, return false
    return false;
  }
}
